export const TABLES_LIST = [
  'myDevices',
  'newDeviceSetup',
  'appSetup',
  'automations',
  'deviceView',
  'myCollection',
  'deviceSettings',
  'profileDependency',
  'masterProfileAssignedDevices',
  'appSetupProfileAssignedDevices',
  'deviceSettingProfileAssignedDevices',
  'selectDeviceSettingProfile',
  'selectAppSetupProfile',
  'selectedProfiles',
  'orderingSelectedProfiles',
  'selectedProfilesReviewPage',
  'androidUpdatesDeployment',
  'deviceUsers',
  'userLoginHistory',
  'wirelessInsight',
  'wifiInsight',
  'wifiDeviceAllAnalysis',
  'wifiDeviceRoamAnalysis',
  'cellularInsights',
  'cellularDeviceAllAnalysis',
  'cellularDeviceVoiceAnalysis',
  'cellularDeviceIPAnalysis',
  'cellularDeviceThroughputAnalysis',
  'logger',
  'loggerZS',
  'loggerDeviceSelection',
  'loggerDetailDevices',
  'selectDependentProfiles',
  'DeviceSettingTargetDevice',
  'MyAppsTargetDevice',
  'licensingTargetDevice',
]
export const MANDATORY_COLUMNS = {
  myDevices: [],
  newDeviceSetup: [],
  appSetup: [],
  automations: [],
  deviceView: [],
  myCollection: [],
  deviceSettings: [],
  profileDependency: [],
  masterProfileAssignedDevices: [],
  appSetupProfileAssignedDevices: [],
  deviceSettingProfileAssignedDevices: [],
  selectDeviceSettingProfile: [],
  selectAppSetupProfile: [],
  selectedProfiles: [],
  orderingSelectedProfiles: [],
  selectedProfilesReviewPage: [],
  androidUpdatesDeployment: [],
  androidUpdatesDeployment: [],
  deviceUsers: [],
  userLoginHistory: [],
  DeviceSettingTargetDevice: [],
  MyAppsTargetDevice: [],
  licensing: [],
  licensingTargetDevice: [],
  wirelessInsight: [
    { label: 'Group Name', value: 'groupName' },
    { label: 'Actions', value: 'actions' },
  ],
  wifiInsight: [
    { label: 'DEVICE NAME', value: 'deviceName' },
    { label: 'VIEW DEVICE', value: 'viewDevice' },
  ],
  wifiDeviceAllAnalysis: [
    { label: 'TIMESTAMP', value: 'utc_timestamp' },
    { label: 'EVENT TYPE (WLAN CODE)', value: 'wlan_code' },
  ],
  wifiDeviceRoamAnalysis: [
    { label: 'TIMESTAMP', value: 'utc_timestamp' },
    { label: 'EVENT TYPE (WLAN CODE)', value: 'wlan_code' },
  ],
  cellularInsights: [
    { label: 'DEVICE NAME', value: 'deviceName' },
    { label: 'VIEW DEVICE', value: 'viewDevice' },
  ],
  cellularDeviceAllAnalysis: [
    { label: 'TIMESTAMP', value: 'utc_timestamp' },
    { label: 'EVENT TYPE', value: 'eventType' },
    { label: 'VIEW EVENT', value: 'viewEvent' },
  ],
  cellularDeviceVoiceAnalysis: [
    { label: 'TIMESTAMP', value: 'utc_timestamp' },
    { label: 'CALL TYPE', value: 'call_Type' },
    { label: 'VIEW EVENT', value: 'viewEvent' },
  ],
  cellularDeviceIPAnalysis: [
    { label: 'TIMESTAMP', value: 'utc_timestamp' },
    { label: 'EVENT TYPE', value: 'eventType' },
    { label: 'VIEW EVENT', value: 'viewEvent' },
  ],
  cellularDeviceThroughputAnalysis: [
    { label: 'TIMESTAMP', value: 'utc_timestamp' },
    { label: 'EVENT TYPE', value: 'eventType' },
    { label: 'VIEW EVENT', value: 'viewEvent' },
  ],
  logger: [],
  loggerZS: [
    { label: 'JOB NAME', value: 'name', width: 200 },
  ],
  loggerDeviceSelection: [],
  loggerDetailDevices: [],
  selectDependentProfiles: [],
}
const assignedDevices = [
  { title: '', value: 'expandable', width: 50 },
  { label: 'Model', value: 'model', width: 80 },
  { label: 'Device Name', value: 'deviceName', width: 200 },
  { label: 'Device Group', value: 'groups', width: 150 },
  { label: 'SERIAL NUMBER', value: 'serialNumber', width: 130 },
  { label: 'DEVICE STATUS', value: 'deviceJobStatus', width: 140 },
  { label: 'STATUS UPDATED', value: 'updatedDateTime', width: 168 },
  { label: 'STATUS DETAILS', value: 'deviceJobDetailStatus', width: 150 },
  { label: 'ACTIONS', value: 'actions', width: 150 },
]
export const OPT_COLUMNS = {
  myDevices: [
    { label: 'Presence Status', value: 'presenceStatus', width: 100 },
    { label: 'Status', value: 'status', width: 100 },
    { label: 'Model', value: 'model', width: 100 },
    { label: 'Device Name', value: 'deviceName', width: 100 },
    { label: 'Device Group', value: 'groups', width: 182 },
    { label: 'OS Version', value: 'formattedOsVersion', width: 115 },
    { label: 'OS BUILD ID', value: 'buildId', width: 115 },
    { label: 'Security Patch Date', value: 'securityPatch', width: 115 },
    { label: 'Serial Number', value: 'serialNumber', width: 125 },
    { label: 'IMEI', value: 'imei', width: 135 },
    { label: 'Battery Health', value: 'batteryType', width: 80 },
    { label: 'Last Connected', value: 'lastConnected', width: 220 },
    { label: 'IP Address', value: 'ipAddress', width: 125 },
    { label: 'Actions', value: 'actions', width: 200 },
  ],
  newDeviceSetup: [
    { label: 'Setup Name', value: 'name', width: 250 },
    { label: 'Setup Category', value: 'category', width: 130 },
    { label: 'Android Updates', value: 'fotaEnabled', width: 140 },
    { label: 'Device Group Assignment', value: 'groups', width: 182 },
    { label: 'Description', value: 'description', width: 182 },
    { label: 'Date Modified', value: 'updatedDateTime', width: 100 },
    { label: 'Actions', value: 'actions', width: 220 },
  ],
  appSetup: [
    { label: 'Setup Name', value: 'name', width: 150 },
    { label: 'Setup Status', value: 'deploymentStatus', width: 140 },
    { label: 'Group', value: 'groups', width: 140 },
    { label: 'App Name', value: 'appName', width: 110 },
    { label: 'App Version', value: 'appVersion', width: 100 },
    { label: 'Hosting Location', value: 'hostingLocation', width: 100 },
    { label: 'Description', value: 'description', width: 175 },
    { label: 'Created', value: 'createdDateTime', width: 100 },
    { label: 'Created By', value: 'createdBy', width: 200 },
    { label: 'Last Applied', value: 'appliedAt', width: 100 },
    { label: 'Last Applied By', value: 'appliedBy', width: 200 },
    { label: 'Last Modified', value: 'updatedDateTime', width: 100 },
    { label: 'Last Modified By', value: 'modifiedBy', width: 200 },
    { label: 'Actions', value: 'actions', width: 350 },
  ],
  deviceView: [
    { label: 'Presence Status', value: 'presenceStatus', width: 100 },
    { label: 'Model', value: 'model', width: 100 },
    { label: 'Update Status', value: 'updateStatus', width: 200 },
    { label: 'Device Name', value: 'deviceName', width: 105 },
    { label: 'Device Group', value: 'groups', width: 182 },
    { label: 'OS Version', value: 'formattedOsVersion', width: 75 },
    { label: 'Security Patch Date', value: 'securityPatch', width: 105 },
    { label: 'OS Build Id', value: 'buildId', width: 75 },
    { label: 'MX Version', value: 'mxVersion', width: 85 },
    { label: 'Serial Number', value: 'serialNumber', width: 150 },
    { label: 'Last Connected', value: 'lastConnected', width: 120 },
    { label: 'Actions', value: 'actions', width: 120 },
  ],
  myCollection: [
    { label: 'App Name', value: 'appName', width: 160 },
    { label: 'Hosting Location', value: 'hostingLocation', width: 140 },
    { label: 'App Version', value: 'appVersion', width: 130 },
    { label: 'Developer', value: 'developer', width: 110 },
    { label: 'Package Name', value: 'appPackage', width: 155 },
    { label: 'App Description', value: 'appDescription', width: 160 },
    { label: 'Actions', value: 'actions', width: 160 },
  ],
  deviceSettings: [
    { label: 'Setting Name', value: 'name', width: 250 },
    { label: 'Setting Status', value: 'deploymentStatus', width: 140 },
    { label: 'Group', value: 'groups', width: 140 },
    { label: 'Description', value: 'description', width: 190 },
    { label: 'Created', value: 'createdDateTime', width: 75 },
    { label: 'Created By', value: 'createdBy', width: 190 },
    { label: 'Last Applied', value: 'appliedAt', width: 75 },
    { label: 'Last Applied By', value: 'appliedBy', width: 190 },
    { label: 'Last Modified', value: 'updatedDateTime', width: 76 },
    { label: 'Last Modified By', value: 'modifiedBy', width: 190 },
    { label: 'Actions', value: 'actions', width: 360 },
  ],
  profileDependency: [
    { title: '', value: 'expandable', width: 50 },
    { label: 'Master Profile Name', value: 'profileDependencyName', width: 250 },
    { label: 'Profile Name', value: 'profileName', width: 250 },
    { label: 'Order', value: 'priority', width: 100 },
    { label: 'Group', value: 'groups', width: 140 },
    { title: 'TYPE', value: 'profileType', width: 120 },
    { title: 'STATUS', value: 'deploymentStatus', width: 140 },
    { title: 'LAST MODIFIED', value: 'updatedDateTime', width: 170 },
    { label: 'Actions', value: 'actions', width: 250 },
  ],
  masterProfileAssignedDevices: [...assignedDevices],
  appSetupProfileAssignedDevices: [...assignedDevices],
  deviceSettingProfileAssignedDevices: [...assignedDevices],
  selectDeviceSettingProfile: [
    { label: 'PROFILE NAME', value: 'name', width: 200 },
    { label: 'PROFILE STATUS', value: 'deploymentStatus', width: 120 },
    { label: 'DESCRIPTION', value: 'description', width: 140 },
    { label: 'CREATED BY', value: 'createdBy', width: 115 },
    { label: 'LAST APPLIED BY', value: 'lastAppliedBy', width: 115 },
    { label: 'LAST MODIFIED BY', value: 'modifiedBy', width: 130 },
  ],
  selectAppSetupProfile: [
    { label: 'SETUP NAME', value: 'name', width: 200 },
    { label: 'SETUP STATUS', value: 'deploymentStatus', width: 120 },
    { label: 'APP VERSION', value: 'appVersion', width: 105 },
    { label: 'HOSTING LOCATION', value: 'hostingLocation', width: 140 },
    { label: 'DESCRIPTION', value: 'description', width: 140 },
    { label: 'LAST MODIFIED', value: 'updatedDateTime', width: 175 },
  ],
  selectedProfiles: [
    { label: 'PROFILE NAME', value: 'name', width: 100 },
    { label: 'PROFILE TYPE', value: 'type', width: 100 },
    { label: 'ACTIONS', value: 'actions', width: 100 },
  ],
  orderingSelectedProfiles: [
    { label: 'DRAG', value: 'drag', width: 60 },
    { label: 'ORDER', value: 'priority', width: 65 },
    { label: 'PROFILE NAME', value: 'name', width: 200 },
    { label: 'PROFILE TYPE', value: 'type', width: 115 },
    { label: 'ACTIONS', value: 'successStatusRequired', width: 225 },
  ],
  selectedProfilesReviewPage: [
    { label: 'ORDER', value: 'priority', width: 60 },
    { label: 'PROFILE NAME', value: 'name', width: 200 },
    { label: 'PROFILE TYPE', value: 'type', width: 100 },
    { label: 'HALT EXECUTION ON FAILURE', value: 'abortOnFailure', width: 150 },
  ],
  androidUpdatesDeployment: [
    { label: 'Deployment Name', value: 'name', width: 120 },
    { label: 'Status', value: 'finalStatus', width: 125 },
    { label: 'Target Device Count', value: 'totalDevices', width: 140 },
    { label: 'Results', value: 'results', width: 100 },
    { label: 'Description', value: 'description', width: 100 },
    { label: 'Completed On', value: 'completedOn', width: 125 },
    { label: 'Actions', value: 'actions', width: 150 },
  ],
  deviceUsers: [
    { label: 'Employee Id', value: 'employeeId', width: 125 },
    { label: 'Group', value: 'group', width: 100 },
    { label: 'Unit', value: 'unit', width: 100 },
    { label: 'Role', value: 'role', width: 100 },
    { label: 'Email', value: 'email', width: 130 },
    { label: 'Language', value: 'language', width: 100 },
    { label: 'Passcode', value: 'passcode', width: 100 },
    { label: 'Security Type(s)', value: 'securityTypes', width: 130 },
    { label: 'User Type', value: 'userType', width: 100 },
    { label: 'Valid Through', value: 'validThrough', width: 100 },
    { label: 'Created On', value: 'createdOn', width: 75 },
    { label: 'Created By Device', value: 'createdByDevice', width: 110 },
    { label: 'Created By S/N', value: 'createdByDeviceSerialNumber', width: 135 },
    { label: 'Updated By', value: 'updatedBy', width: 110 },
    { label: 'Last Log-In', value: 'lastLogIn', width: 75 },
    { label: 'Last Log-In Device', value: 'lastLogInDevice', width: 100 },
    { label: 'Last Log-In S/N', value: 'lastLogInDeviceSerialNumber', width: 132 },
    { label: 'Enrollment Id', value: 'enrollmentId', width: 120 },
    { label: 'Enrollment Status', value: 'activeType', width: 120 }, // EDCL-293
    { label: 'Actions', value: 'actions', width: 130 },
  ],
  userLoginHistory: [
    { label: 'MODEL', value: 'deviceModel', width: 95 },
    { label: 'DEVICE NAME', value: 'deviceName', width: 95 },
    { label: 'SERIAL NUMBER', value: 'deviceSerialNumber', width: 95 },
    { label: 'SIGN IN', value: 'loggedInOn', width: 75 },
    { label: 'SIGN OUT', value: 'loggedOutOn', width: 75 },
  ],
  wirelessInsight: [
    { label: 'TOTAL DEVICE COUNT', value: 'deviceCount' },
    { label: 'WI-FI DEVICE COUNT', value: 'wifiDeviceCount' },
    { label: 'CELLULAR DEVICE COUNT', value: 'cellularDeviceCount' },
    { label: 'WI-FI FAILURES', value: 'wifiFailures' },
    { label: 'CELLULAR FAILURES', value: 'cellularFailures' },
    { label: 'WI-FI QUALITY', value: 'wifiQuality' },
    { label: 'CELLULAR QUALITY', value: 'cellularQuality' },
  ],
  wifiInsight: [
    { label: 'MODEL', value: 'deviceModel' },
    { label: 'STATUS', value: 'isDeleted' },
    { label: 'WI-FI FAILURES', value: 'wifiFailures' },
    { label: 'WI-FI QUALITY', value: 'wifiQuality' },
    { label: 'SERIAL NUMBER', value: 'serial' },
    { label: 'OS VERSION', value: 'osVersion' },
    { label: 'SECURITY PATCH DATE', value: 'securityPatchDate' },
  ],
  wifiDeviceAllAnalysis: [
    // { label: 'TIMESTAMP', value: 'utc_timestamp' },
    // { label: 'EVENT TYPE (WLAN CODE)', value: 'wlan_code' },
    { label: 'REASON CODE', value: 'reason' },
    { label: 'CONNECTED BSSID', value: 'from_bssid' },
    { label: 'ROAM TO AP BSSID', value: 'to_bssid' },
    { label: 'CONNECTED RSSI', value: 'from_rssi' },
    { label: 'ROAM TO AP RSSI', value: 'to_rssi' },
    { label: 'CONNECTED CHANNEL', value: 'from_channel' },
    { label: 'ROAM TO AP CHANNEL', value: 'to_channel' },
    { label: 'VOICE STATS', value: 'voiceStats' },
  ],
  wifiDeviceRoamAnalysis: [
    { label: 'REASON CODE', value: 'reason' },
    { label: 'CONNECTED BSSID', value: 'from_bssid' },
    { label: 'ROAM TO AP BSSID', value: 'to_bssid' },
    { label: 'CONNECTED RSSI', value: 'from_rssi' },
    { label: 'ROAM TO AP RSSI', value: 'to_rssi' },
    { label: 'CONNECTED CHANNEL', value: 'from_channel' },
    { label: 'ROAM TO AP CHANNEL', value: 'to_channel' },
  ],
  cellularInsights: [
    { label: 'MODEL', value: 'deviceModel' },
    { label: 'STATUS', value: 'isDeleted' },
    { label: 'CELLULAR FAILURES', value: 'cellularFailures' },
    { label: 'CELLULAR QUALITY', value: 'cellularQuality' },
    { label: 'SERIAL NUMBER', value: 'serial' },
    { label: 'OS VERSION', value: 'osVersion' },
    { label: 'SECURITY PATCH DATE', value: 'securityPatchDate' },
    { label: 'LOCATION', value: 'location' },
  ],
  cellularDeviceAllAnalysis: [
    { label: 'SUB ID', value: 'subscription_id' },
    { label: 'SPN', value: 'operator_name' },
    { label: 'RAT', value: 'rat' },
    { label: 'SIGNAL QUALITY', value: 'signal_strength' },
  ],
  cellularDeviceVoiceAnalysis: [
    { label: 'SUB ID', value: 'subscription_id' },
    { label: 'SPN', value: 'operator_name' },
    { label: 'RAT', value: 'rat' },
    { label: 'ERROR CODE', value: 'error_code' },
    { label: 'SIGNAL QUALITY', value: 'signal_strength' },
  ],
  cellularDeviceIPAnalysis: [
    { label: 'SUB ID', value: 'subscription_id' },
    { label: 'SPN', value: 'operator_name' },
    { label: 'RAT', value: 'rat' },
    { label: 'SIGNAL QUALITY', value: 'signal_strength' },
  ],
  cellularDeviceThroughputAnalysis: [
    { label: 'SUB ID', value: 'subscription_id' },
    { label: 'SPN', value: 'operator_name' },
    { label: 'RAT', value: 'rat' },
    { label: 'SIGNAL QUALITY', value: 'signal_strength' },
  ],
  logger: [
    { label: 'JOB NAME', value: 'name', width: 100 },
    { label: 'STATUS', value: 'deploymentStatus', width: 80 },
    { label: 'HOSTING LOCATION', value: 'hostingLocation', width: 100 },
    { label: 'DATE COLLECTED', value: 'date', width: 100 },
    // { label: 'DEVICE NAME', value: 'deviceNames' },
    // { label: 'DEVICE GROUP', value: 'groups' },
    { label: 'DESCRIPTION', value: 'description', width: 100 },
  ],
  loggerZS: [
    { label: 'STATUS', value: 'deploymentStatus', width: 80 },
    { label: 'HOSTING LOCATION', value: 'hostingLocation', width: 100 },
    { label: 'DATE CREATED', value: 'date', width: 80 },
    { label: 'DESCRIPTION', value: 'description', width: 100 },
    { label: 'ACTIONS', value: 'actions', width: 200 },
  ],
  loggerDeviceSelection: [
    { label: 'Model', value: 'model' },
    { label: 'Device Name', value: 'deviceName' },
    { label: 'Device Group', value: 'groups' },
    { label: 'OS Version', value: 'formattedOsVersion' },
    { label: 'MX Version', value: 'mxVersion' },
    { label: 'OS Build Id', value: 'buildId' },
    //{ label: 'Security Patch Date', value: 'securityPatch' },
    { label: 'Serial Number', value: 'serialNumber' },
    //{ label: 'IMEI', value: 'imei' },
    //{ label: 'Battery Health', value: 'batteryType' },
    //{ label: 'Last Connected', value: 'lastConnected' },
    //{ label: 'IP Address', value: 'ipAddress' },
    //{ label: 'Actions', value: 'actions' },
  ],
  loggerDetailDevices: [
    { label: 'Model', value: 'model' },
    { label: 'Device Name', value: 'deviceName' },
    { label: 'Device Group', value: 'groups' },
    //{ label: 'Security Patch Date', value: 'securityPatch' },
    { label: 'Serial Number', value: 'serialNumber' },
    { label: 'Status', value: 'deviceJobStatus' },
    //{ label: 'IMEI', value: 'imei' },
    //{ label: 'Battery Health', value: 'batteryType' },
    { label: 'Date Collected', value: 'updatedDateTime' },
    //{ label: 'IP Address', value: 'ipAddress' },
    //{ label: 'Actions', value: 'actions' },
    { label: 'ACTION', value: 'action' }, //EDCL-123
  ],
  selectDependentProfiles: [
    { label: 'PROFILE NAME', value: 'name' },
    { label: 'APP VERSION', value: 'appVersion' },
    { label: 'HOSTING LOCATION', value: 'hostingLocation' },
    { label: 'PROFILE STATUS', value: 'deploymentStatus' },
    { label: 'DESCRIPTION', value: 'description' },
    { label: 'CREATED BY', value: 'createdBy' },
    { lable: 'LAST APPLIED BY', value: 'lastAppliedBy' },
    { label: 'LAST MODIFIED BY', value: 'modifiedBy' },
    { label: 'LAST MODIFIED', value: 'updatedDateTime' },
  ],
  automations: [],
  DeviceSettingTargetDevice: [],
  MyAppsTargetDevice: [],
  licensing: [],
  licensingTargetDevice: [],
}
export const HIDDEN_COLUMNS = {
  myDevices: [
    { label: 'Last Connected', value: 'lastConnected', width: 220 },
    { label: 'IP Address', value: 'ipAddress', width: 125 },
  ],
  newDeviceSetup: [],
  appSetup: [
    { label: 'Created', value: 'createdDateTime', width: 100 },
    { label: 'Created By', value: 'createdBy', width: 200 },
    { label: 'Last Applied', value: 'appliedAt', width: 100 },
    { label: 'Last Applied By', value: 'appliedBy', width: 200 },
    { label: 'Last Modified By', value: 'modifiedBy', width: 200 },
  ],
  deviceView: [{ label: 'Last Connected', value: 'lastConnected', width: 120 }],
  myCollection: [],
  deviceSettings: [
    { label: 'Created', value: 'createdDateTime', width: 75 },
    { label: 'Created By', value: 'createdBy', width: 190 },
    { label: 'Last Applied', value: 'appliedAt', width: 75 },
    { label: 'Last Applied By', value: 'appliedBy', width: 190 },
    { label: 'Last Modified By', value: 'modifiedBy', width: 190 },
  ],
  profileDependency: [],
  masterProfileAssignedDevices: [],
  appSetupProfileAssignedDevices: [],
  deviceSettingProfileAssignedDevices: [],
  selectDeviceSettingProfile: [],
  selectAppSetupProfile: [],
  selectedProfiles: [],
  orderingSelectedProfiles: [],
  selectedProfilesReviewPage: [],
  androidUpdatesDeployment: [],
  deviceUsers: [
    { label: 'Valid Through', value: 'validThrough', width: 100 },
    { label: 'Created On', value: 'createdOn', width: 75 },
    { label: 'Created By Device', value: 'createdByDevice', width: 110 },
    { label: 'Created By S/N', value: 'createdByDeviceSerialNumber', width: 135 },
    { label: 'Enrollment Id', value: 'enrollmentId', width: 120 },
    { label: 'Email', value: 'email', width: 130 },
    { label: 'Last Log-In Device', value: 'lastLogInDevice', width: 132 },
    { label: 'Updated By', value: 'updatedBy', width: 110 },
  ],
  userLoginHistory: [],
  wirelessInsight: [],
  wifiInsight: [],
  wifiDeviceAllAnalysis: [],
  wifiDeviceRoamAnalysis: [],
  cellularInsights: [],
  cellularDeviceAllAnalysis: [],
  cellularDeviceVoiceAnalysis: [],
  cellularDeviceIPAnalysis: [],
  cellularDeviceThroughputAnalysis: [],
  logger: [],
  loggerZS: [],
  loggerDeviceSelection: [
    // { label: 'Last Connected', value: 'lastConnected' },
    // { label: 'IP Address', value: 'ipAddress' },
  ],
  loggerDetailDevices: [],
  selectDependentProfiles: [],
  automations: [],
  DeviceSettingTargetDevice: [],
  MyAppsTargetDevice: [],
  licensing: [],
  licensingTargetDevice: [],
}
